import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const LABEL_MAKER_ACTIVITY_FRAGMENT = gql `
  fragment LabelMakerActivityFragment on LabelMakerActivity {
    rounds {
      contentImage {
        image {
          ...AssetFragment
        }
      }
      steps {
        answer
        answerAudio {
          audio {
            ...AssetFragment
          }
        }
        id
        position {
          x
          y
        }
      }
    }
  }
  ${ASSET_FRAGMENT}
`;
export default LABEL_MAKER_ACTIVITY_FRAGMENT;
